module.exports = __webpack_public_path__ + "static/img/about_cooperate_02_zh.0abfb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_02_zh.png
// module id = wie9
// module chunks = 34